"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import { Button, TextField } from "@nxt-costco-com/forge-components";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../../Analytics/index.js";
import { MarketingTypography } from "../../../Marketing/MarketingTypography/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { StyledBrandedSearchContainer, maxWidth } from "./styles.js";
function BrandedSearchCLPUI({
  data,
  onClickHandler
}) {
  var _a, _b, _c, _d, _e;
  const [keyword, setKeyword] = useState("");
  const handleChange = (event) => {
    setKeyword(event.target.value);
  };
  const brandedSearchButtonLabel = data == null ? void 0 : data.button_label;
  const searchLabelText = data == null ? void 0 : data.search_placeholder_text;
  const SearchButton = useMemo(() => {
    return /* @__PURE__ */ jsx(
      Analytics,
      {
        analyticData: {
          identifier: "searchTerm",
          keyword,
          searchBar: {
            searchType: "Marketing Search"
          },
          trackType: "search"
        },
        children: /* @__PURE__ */ jsx(
          Button,
          {
            onClick: () => {
              if (onClickHandler) {
                onClickHandler(keyword);
              }
            },
            children: brandedSearchButtonLabel
          }
        )
      }
    );
  }, [brandedSearchButtonLabel, keyword, onClickHandler]);
  return /* @__PURE__ */ jsx(
    StyledBrandedSearchContainer,
    {
      backgroundColor: ((_b = (_a = data == null ? void 0 : data.background_color) == null ? void 0 : _a.background_color) == null ? void 0 : _b.hex) || "",
      imageUrl: ((_d = (_c = data == null ? void 0 : data.background_image) == null ? void 0 : _c[0]) == null ? void 0 : _d.url) || "",
      "data-testid": "brandedSearch",
      children: /* @__PURE__ */ jsxs(
        CostcoBox,
        {
          sx: {
            maxWidth: `${maxWidth} !important`
          },
          children: [
            (_e = data == null ? void 0 : data.search_title_config) == null ? void 0 : _e.map((content, index) => {
              var _a2, _b2;
              const brandedSearchDataTextColor = ((_b2 = (_a2 = content == null ? void 0 : content.color) == null ? void 0 : _a2.text_color) == null ? void 0 : _b2.hex) || "";
              const brandedSearchDataTextType = (content == null ? void 0 : content.select_text_type) || "body";
              const brandedSearchDataSemanticsType = content == null ? void 0 : content.select_semantics_type;
              const brandedSearchDataMarkdownText = (content == null ? void 0 : content.markdown_text) || "";
              return /* @__PURE__ */ jsx(
                MarketingTypography,
                {
                  sx: {
                    color: brandedSearchDataTextColor
                  },
                  component: brandedSearchDataSemanticsType,
                  uniqueId: `brandedSearch_${brandedSearchDataTextType}_${index}`,
                  variant: brandedSearchDataTextType,
                  isMarkdown: true,
                  children: brandedSearchDataMarkdownText
                },
                index
              );
            }),
            /* @__PURE__ */ jsx(CostcoBox, { sx: { paddingTop: SpaceMd }, children: /* @__PURE__ */ jsx(
              TextField,
              {
                endAdornment: SearchButton,
                endAdornmentId: "searchButton",
                id: "brandedSearchTextbox",
                inputAriaLabelledBy: `brandedSearchTextboxLabel searchTitle`,
                inputLabelId: "brandedSearchTextboxLabel",
                isRequired: false,
                label: searchLabelText,
                labelOptionalText: " ",
                onChange: handleChange,
                onKeyDown: (event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    event.stopPropagation();
                    if (onClickHandler) {
                      onClickHandler(keyword);
                    }
                  }
                },
                value: keyword
              }
            ) })
          ]
        }
      )
    }
  );
}
export {
  BrandedSearchCLPUI
};
